import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Tabs from './Tabs';
import Tab from './Tab';
import Translate from './Translate';
import { DataStore } from '../stores';

interface ModuleTabsProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
}

const ModuleTabs: React.SFC<ModuleTabsProps> = ({ theme, dataStore }) => (
    <Tabs marginY="lg" {...theme.ModuleTabs}>
        {dataStore.config.modules.map((module, index) => (
            <Tab
                key={module.id}
                onClick={() => dataStore.config.setModule(module)}
                isSelected={module.id === dataStore.config.selectedModule.id}
                {...theme.ModuleTab}
            >
                <Translate>{module.label}</Translate>
            </Tab>
        ))}
    </Tabs>
);

export default inject('dataStore')(observer(withTheme(ModuleTabs)));



// WEBPACK FOOTER //
// ./src/Components/ModuleTabs.tsx